
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Kreiranje kontrolne ploče',
	'dashboard': 'Kontrolna ploča',
	'dashboardTemplate': 'Predložak kontrolne ploče',
	'createAV': 'Kreiraj',
	'createAvEditNameLabel': '1. Navedite naziv pogleda',
	'createAvSelectTemplateLabel': '2. Izaberite predložak',
	'tabLayoutLabel': 'Predložak s karticama',
	'infographicsLayoutLabel': 'Infografički predložak',
	'singlePageLayoutLabel': 'Predložak pojedinačne stranice',
	'customLayoutLabel': 'Prilagođeni predložak',
	'freeformTemplate': 'Slobodan oblik',
	'freeformTemplateDesc': 'U prikazu slobodnog oblika vizualizacije se prikazuju onako kako ste ih postavili u pogledu, bez obzira na veličinu ekrana. U drugim načinima prikaza se veličina i položaj vizualizacija prilagođavaju tako da stanu na ekran.',
	'NoTemplate': 'Slobodni oblik',
	'Template1': 'Prazno',
	'Template2': 'Naslov 1 puta 2',
	'Template3': '2 preko 1',
	'Template4': '4 preko 1',
	'Template5': 'Podnožje 1 puta 2',
	'Template6': '3 pored 1 preko 1',
	'Template7': '4 pored 3 preko 1',
	'Template8': '2 preko 3 puta 2',
	'Template9': '2 puta 2',
	'Template10': '1 puta 2 pored 2 puta 2 preko 1',
	'Template11': '3 puta 1 preko 1 puta 2',
	'Template12': '2 preko 1 pored 1 puta 2',
	'Template13': '1 pored 1 puta 2 pored 1 puta 4',
	'Template22': '1 preko 2 puta 2',
	'Template14': '1 pored 1',
	'Template15': '1 preko 1 pored 1',
	'Template16': '1 pored 1 preko 1',
	'Template17': '1 preko 1 pored 1 preko 1',
	'Template18': '1 preko 1 pored 1',
	'Template19': '1 preko 2 pored 1',
	'Template20': '1 preko 2 puta 1',
	'Template21': '1 preko 1 preko 2 puta 1',
	'Template23': 'Prazno sa zonom ispuštanja',
	'Infographics1': 'Prazno',
	'Infographics2': '4 reda',
	'Infographics3': '4 reda sa zaglavljima',
	'Infographics4': '2 puta 4',
	'Infographics5': 'Veliki prikaz na vrhu s 2 puta 2',
	'Infographics6': '2 puta 4 s okomitom prazninom',
	'Infographics7': '2 puta 4 stepenasto',
	'Infographics8': 'Tenisko igralište',
	'Infographics9': '3 puta 4',
	'Infographics10': '4 puta 8',
	'createAvDashboardLabel': 'Izgled',
	'dashboard_template_save_success': 'Vaš predložak kontrolne ploče je spremljen.',
	'dashboard_template_prefix': 'Predložak: "%{name}"',
	'dashboard_template_filters_removed': 'Filteri na platnu su uklonjeni.',
	'createAvTabLabel': 'Kartice',
	'createAvInfographicsLabel': 'Infografika',
	'createAvSinglepageLabel': 'Pojedinačna stranica',
	'createAvCustomLabel': 'Prilagođeno',
	'loadMoreLabel': 'Učitaj više...',
	'backLabel': 'Idi natrag',
	'addSourceLabel': 'Dodaj izvor',
	'pinLabel': 'Prikvači',
	'errorLoadingDataSetMetaData': 'Došlo je do greške tijekom čitanja meta podataka',
	'errorLoadingDataSets': 'Dogodila se greška tijekom učitavanja liste skupova podataka',
	'errorLoadingDataSet': 'Nisu se učitali meta podaci za skup podataka "%{datasetName}". Molim, kontaktirajte administratora za detalje.',
	'okButton': 'OK',
	'createButton': 'Kreiraj',
	'cancelButton': 'Opoziv',
	'copyButton': 'Kopiraj',
	'selectTemplateLabel': 'Izbor predloška',
	'createBoardTitle': 'Kreirajte kontrolnu ploču',
	'createBoardSubtitle': 'Izaberite predložak za svoju kontrolnu ploču',
	'noSourcesSelectedLabel': 'Nema izabranog izvora',
	'find_label': 'Traži',
	'noDashboardFound': 'Kontrolna ploča se ne može dohvatiti. Možda više ne postoji ili nemate dovoljne povlastice da biste ga vidjeli.',
	'errorLabel': 'Greška',
	'defaultName': 'Nova kontrolna ploča',
	'noDashboardCapability': 'Nemate sposobnost izvođenja aplikacije kontrolne ploče',
	'noDashboardPermission': 'Nemate dovoljne povlastice za gledanje ove kontrolne ploče',
	'sourceNotFound': 'Ne možemo učitati vizualizaciju jer njezin pridruženi izvor "%{sourceName}" nije  dostupan',
	'cmDuplicateName': 'Stavka s ovim nazivom već postoji. Pokušajte s drugim nazivom',
	'cmEmptySelection': 'Kontrolna ploča je izbrisana. Pokušajte spremiti kao novu kontrolnu ploču.',
	'propTheme': 'Vizualna tema',
	'legacyThemeLabel': 'Naslijeđeno',
	'carbonGrey10Label': 'Carbon X svijetlo',
	'carbonGrey100Label': 'Carbon X tamno',
	'titleTextLabel': 'Naslov',
	'titleSmallTextLabel': 'Mali naslov',
	'subtitleTextLabel': 'Podnaslov',
	'bodyTextLabel': 'Tijelo',
	'bodySmallTextLabel': 'Malo tijelo',
	'captionTextLabel': 'Zaglavlje',
	'quoteTextLabel': 'Citat',
	'quoteSmallTextLabel': 'Mali citat',
	'responsiveTextLabel': 'Automatska veličina',
	'mediaWidgetLabel': 'Medij',
	'webpageWidgetLabel': 'Web stranica',
	'imageWidgetLabel': 'Slika',
	'textWidgetLabel': 'Tekst',
	'notebookWidgetLabel': 'Bilježnica',
	'multipurposeWidgetLabel': 'Višenamjenski',
	'textPlaceHolder': 'Kliknite za uređivanje teksta',
	'titlePlaceHolder': 'Kliknite za uređivanje naslova',
	'toggleEditModeLabel': 'Prebaci na uređivanje',
	'togglePreviewModeLabel': 'Prebaci na pregled',
	'editDashboardCoachMarkTitle': 'Uredi kontrolnu ploču',
	'editDashboardCoachMarkContents': 'Kliknite na ikonu olovke za uređivanje ove kontrolne ploče.',
	'addDataCoachMarkTitle': 'Dodaj podatke',
	'addDataDashboardCoachMarkContents': 'Povucite i ispustite podatke iz panela podataka na kontrolnu ploču.',
	'pageSelectWarning': 'Molim, izaberite karticu.',
	'screenshot_label': 'Kontrolna ploča %{title}',
	'screenshot_label_tab': 'Kartica %{tabName} kontrolne ploče %{title}',
	'dataAssetPropertiesLabel': 'Svojstva vizualizacije',
	'modelFilter': 'Filter',
	'invertSelectionToolTip': 'Preokreni izbore filtera',
	'clearFilterValueToolTip': 'Isprazni vrijednosti filtera',
	'invertFilterSelection': 'Preokreni',
	'clearTextFilterValue': 'Isprazni',
	'filterConditionLabel': 'Uvjet filtera',
	'applyFilter': 'Primijeni filter',
	'itemCountText': '%{itemCount} stavki je izabrano',
	'itemExcludeCountText': '%{itemCount} stavki je isključeno',
	'moreMembers': 'Pokaži više...',
	'searchHierarchyMembers': 'Koristi pretraživanje za nalaženje članova...',
	'propHideEmpty': 'Sakrij prazno',
	'propColorOrder': 'Redoslijed boja',
	'propElementColor': 'Boja elementa vizualizacije',
	'propLineColor': 'Boja linije',
	'propLineAndSymbolColor': 'Boja linija i simbola',
	'propColumnColor': 'Boja stupca',
	'propBarColor': 'Boja trake',
	'propWordColor': 'Boja teksta',
	'propAreaColor': 'Boja površine',
	'propRadialbarColor': 'Boja radijalne trake',
	'propColorPalettes': 'Palete boja',
	'propDashboardColorPalette': 'Trenutna paleta kontrolne ploče',
	'propNewDashboardPaletteLabel': 'Kreiraj prilagođenu paletu kontrolne ploče',
	'propDashboardChangePaletteLink': 'Promijeni paletu kontrolne ploče',
	'propHideLeafNode': 'Sakrij oznake listova',
	'propOpacity': 'Prozirnost',
	'propOpacityDescription': 'Čini objekt više ili manje prozirnim. Upišite vrijednost između 0 i 100',
	'addATab': 'Dodaj novu karticu',
	'propFredIsRed': 'Dosljednost boja',
	'areaChartCaption': 'Površinski grafikon',
	'areaChartDataSlot_categoriesLabel': 'Oznaka osi',
	'areaChartDataSlot_valuesLabel': 'Vrijednost',
	'areaChartProp_colorPaletteLabel': 'Palete boja',
	'areaChartProp_lineColorLabel': 'Boja površine',
	'areaChartProp_interpolationLabel': 'Glatke linije',
	'areaChartProp_interpolationDescription': 'Linije koje spajaju točke podataka su zakrivljene.',
	'areaChartProp_hideGridLinesLabel': 'Sakrij mrežne linije',
	'areaChartProp_hideGridLinesDescription': 'Sakrij mrežne linije',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'areaChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'areaChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'areaChartProp_suppressZerosLabel': 'Sakrij prazno',
	'areaChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'barChartCaption': 'Trakasti grafikon',
	'barChartDataSlot_categoriesLabel': 'Oznaka osi',
	'barChartDataSlot_valuesLabel': 'Vrijednost',
	'barChartProp_colorPaletteLabel': 'Palete boja',
	'barChartProp_elementColorLabel': 'Boja trake',
	'barChartProp_hideGridLinesLabel': 'Sakrij mrežne linije',
	'barChartProp_hideGridLinesDescription': 'Sakrij mrežne linije',
	'barChartProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'barChartProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'barChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'barChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'barChartProp_suppressZerosLabel': 'Sakrij prazno',
	'barChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'columnChartCaption': 'Stupac',
	'columnChartDataSlot_categoriesLabel': 'Oznaka osi',
	'columnChartDataSlot_valuesLabel': 'Vrijednost',
	'columnChartProp_colorPaletteLabel': 'Palete boja',
	'columnChartProp_elementColorLabel': 'Boja stupca',
	'columnChartProp_hideGridLinesLabel': 'Sakrij mrežne linije',
	'columnChartProp_hideGridLinesDescription': 'Sakrij mrežne linije',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'columnChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'columnChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'columnChartProp_suppressZerosLabel': 'Sakrij prazno',
	'columnChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'bubbleChartCaption': 'Mjehuričasti grafikon',
	'bubbleChartDataSlot_xAxisLabel': 'Vodoravna os',
	'bubbleChartDataSlot_yAxisLabel': 'Okomita os',
	'bubbleChartDataSlot_sizeLabel': 'Veličina po',
	'bubbleChartDataSlot_colorLabel': 'Boja po',
	'bubbleChartProp_colorPaletteLabel': 'Palete boja',
	'bubbleChartProp_hideGridLinesLabel': 'Sakrij mrežne linije',
	'bubbleChartProp_hideGridLinesDescription': 'Sakrij mrežne linije',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'bubbleChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'bubbleChartProp_hideLegendLabel': 'Sakrij legendu',
	'bubbleChartProp_hideLegendDescription': 'Sakrij legendu.',
	'bubbleChartProp_legendPositionLabel': 'Položaj legende',
	'lineChartCaption': 'Linija',
	'lineChartDataSlot_categoriesLabel': 'Oznaka osi',
	'lineChartDataSlot_valuesLabel': 'Vrijednost',
	'lineChartProp_colorPaletteLabel': 'Palete boja',
	'lineChartProp_lineColorLabel': 'Boja linija i simbola',
	'lineChartProp_symbolShapeLabel': 'Oblik simbola',
	'lineChartProp_hideSymbolsLabel': 'Sakrij simbole',
	'lineChartProp_hideSymbolsDescription': 'Sakrij simbole',
	'lineChartProp_hideDataLinesLabel': 'Sakrij liniju(e)',
	'lineChartProp_hideDataLinesDescription': 'Sakrij liniju(e)',
	'lineChartProp_interpolationLabel': 'Glatke linije',
	'lineChartProp_interpolationDescription': 'Linije koje spajaju točke podataka su zakrivljene.',
	'lineChartProp_hideGridLinesLabel': 'Sakrij mrežne linije',
	'lineChartProp_hideGridLinesDescription': 'Sakrij mrežne linije',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'lineChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'lineChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'lineChartProp_suppressZerosLabel': 'Sakrij prazno',
	'lineChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'packedBubbleChart1CatCaption': 'Pakirani mjehuričasti grafikon',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategorije',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Veličina po',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Palete boja',
	'packedBubbleChart1CatProp_elementColorLabel': 'Boja mjehurića',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Sakrij oznaku',
	'packedBubbleChart1CatProp_hideValueLabel': 'Sakrij vrijednost',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Sakrij prazno',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'heatChartCaption': 'Toplinski',
	'heatChartDataSlot_valuesLabel': 'Toplinski po',
	'heatChartDataSlot_xAxisLabel': 'Vodoravna os',
	'heatChartDataSlot_yAxisLabel': 'Okomita os',
	'heatChartProp_colorPaletteLabel': 'Palete boja',
	'heatChartProp_heatScalePaletteLabel': 'Redoslijed boja',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'heatChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'heatChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'heatChartProp_suppressZerosLabel': 'Sakrij prazno',
	'heatChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'heatChartProp_hideLegendLabel': 'Sakrij legendu',
	'heatChartProp_hideLegendDescription': 'Sakrij legendu.',
	'heatChartProp_legendPositionLabel': 'Položaj legende',
	'pieChartCaption': 'Tortni grafikon',
	'pieChartDataSlot_categoriesLabel': 'Kategorije',
	'pieChartDataSlot_valuesLabel': 'Vrijednost',
	'pieChartProp_colorPaletteLabel': 'Palete boja',
	'pieChartProp_hideRadialValueLabel': 'Sakrij vrijednost',
	'pieChartProp_pieAsDonutLabel': 'Pokaži kao prstenasti grafikon',
	'pieChartProp_pieAsDonutDescription': 'Pokaži kao prstenasti grafikon',
	'pieChartProp_suppressZerosLabel': 'Sakrij prazno',
	'pieChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'pieChartProp_hideLegendLabel': 'Sakrij legendu',
	'pieChartProp_hideLegendDescription': 'Sakrij legendu.',
	'pieChartProp_legendPositionLabel': 'Položaj legende',
	'map1measureCaption': 'Mapa',
	'map1measureDataSlot_categoriesLabel': 'Regije',
	'map1measureDataSlot_valuesLabel': 'Toplina regije',
	'map1measureProp_colorPaletteLabel': 'Palete boja',
	'map1measureProp_heatScalePaletteLabel': 'Redoslijed boja',
	'map1measureProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'map1measureProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'map1measureProp_suppressZerosLabel': 'Sakrij prazno',
	'map1measureProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'map1measureProp_hideLegendLabel': 'Sakrij legendu',
	'map1measureProp_hideLegendDescription': 'Sakrij legendu.',
	'map1measureProp_legendPositionLabel': 'Položaj legende',
	'radialChartCaption': 'Radijalni grafikon',
	'radialChartDataSlot_categoriesLabel': 'Kategorije',
	'radialChartDataSlot_valuesLabel': 'Vrijednost',
	'radialChartProp_colorPaletteLabel': 'Palete boja',
	'radialChartProp_elementColorLabel': 'Boja radijalne trake',
	'radialChartProp_hideRadialTitleLabel': 'Sakrij naslov',
	'radialChartProp_hideRadialValueLabel': 'Sakrij vrijednost',
	'radialChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'radialChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'radialChartProp_suppressZerosLabel': 'Sakrij prazno',
	'radialChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'pointChart1catCaption': 'Točkasti grafikon',
	'pointChart1catDataSlot_valuesLabel': 'Vrijednost',
	'pointChart1catDataSlot_categoriesLabel': 'Oznaka osi',
	'pointChart1catProp_colorPaletteLabel': 'Palete boja',
	'pointChart1catProp_elementColorLabel': 'Boja oblika',
	'pointChart1catProp_symbolShapeLabel': 'Oblik simbola',
	'pointChart1catProp_symbolFillLabel': 'Oblik ispune',
	'pointChart1catProp_symbolFillDescription': 'Pokaži boje ispune za simbole.',
	'pointChart1catProp_hideGridLinesLabel': 'Sakrij mrežne linije',
	'pointChart1catProp_hideGridLinesDescription': 'Sakrij mrežne linije',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'pointChart1catProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'pointChart1catProp_suppressZerosLabel': 'Sakrij prazno',
	'pointChart1catProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'scatterPlotChartNoCatCaption': 'Raspršeni grafikon',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Vodoravna os',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Okomita os',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Palete boja',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Boja elementa',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Oblik simbola',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Oblik ispune',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Pokaži boje ispune za simbole.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Sakrij mrežne linije',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Sakrij mrežne linije',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'radialBarChartCaption': 'Radijalni trakasti',
	'radialBarChartDataSlot_categoriesLabel': 'Kategorije',
	'radialBarChartDataSlot_valuesLabel': 'Vrijednost',
	'radialBarChartProp_colorPaletteLabel': 'Palete boja',
	'radialBarChartProp_elementColorLabel': 'Boja radijalne trake',
	'radialBarChartProp_hideRadialTitleLabel': 'Sakrij naslov',
	'radialBarChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'radialBarChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'radialBarChartProp_suppressZerosLabel': 'Sakrij prazno',
	'radialBarChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'lineColumnComboChartCaption': 'Linijski i stupčasti grafikon',
	'lineColumnComboChartDataSlot_categoryLabel': 'Oznaka osi',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Linijski',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Stupčasti',
	'lineColumnComboChartProp_colorPaletteLabel': 'Palete boja',
	'lineColumnComboChartProp_elementColorLabel': 'Boja stupca',
	'lineColumnComboChartProp_lineColorLabel': 'Boja linija i simbola',
	'lineColumnComboChartProp_symbolShapeLabel': 'Oblik simbola',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Sakrij simbole',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Sakrij simbole',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Sakrij liniju(e)',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Sakrij liniju(e)',
	'lineColumnComboChartProp_interpolationLabel': 'Glatke linije',
	'lineColumnComboChartProp_interpolationDescription': 'Linije koje spajaju točke podataka su zakrivljene.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Sakrij mrežne linije',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Sakrij mrežne linije',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Sakrij oznake naslova osi',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Sakrij naslove za osi.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Sakrij prazno',
	'lineColumnComboChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'lineColumnComboChartProp_hideLegendLabel': 'Sakrij legendu',
	'lineColumnComboChartProp_hideLegendDescription': 'Sakrij legendu.',
	'lineColumnComboChartProp_legendPositionLabel': 'Položaj legende',
	'summaryCaption': 'Sumiranje',
	'areaName': 'Površinski grafikon',
	'areaDescription': 'Površinski grafikon',
	'areaDataSlot_colorLabel': 'Boja po',
	'areaDataSlot_valuesLabel': 'Vrijednost',
	'areaDataSlot_categoriesLabel': 'Oznaka osi',
	'bubbleName': 'Mjehuričasti grafikon',
	'bubbleDescription': 'Mjehuričasti grafikon',
	'bubbleDataSlot_yAxisLabel': 'Okomita os',
	'bubbleDataSlot_xAxisLabel': 'Vodoravna os',
	'bubbleDataSlot_sizeLabel': 'Veličina po',
	'bubbleDataSlot_colorLabel': 'Boja po',
	'clusterBarName': 'Trakasti grafikon',
	'clusterBarDescription': 'Trakasti grafikon',
	'clusterBarDataSlot_colorLabel': 'Boja po',
	'clusterBarDataSlot_valuesLabel': 'Vrijednost',
	'clusterBarDataSlot_categoriesLabel': 'Oznaka osi',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Vrijednost',
	'clusterColumnName': 'Stupac',
	'clusterColumnDescription': 'Stupac',
	'clusterColumnDataSlot_colorLabel': 'Boja po',
	'clusterColumnDataSlot_valuesLabel': 'Vrijednost',
	'clusterColumnDataSlot_categoriesLabel': 'Oznaka osi',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Vrijednost',
	'clusterLineName': 'Linija',
	'clusterLineDescription': 'Linija',
	'clusterLineDataSlot_colorLabel': 'Boja po',
	'clusterLineDataSlot_valuesLabel': 'Okomita os',
	'clusterLineDataSlot_categoriesLabel': 'Vodoravna os',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Vrijednost',
	'gridName': 'Mreža',
	'gridDescription': 'Mreža',
	'gridDataSlot_grid_colsLabel': 'Stupac',
	'heatName': 'Toplinski',
	'heatDescription': 'Toplinski',
	'heatDataSlot_yAxisLabel': 'Okomita os',
	'heatDataSlot_xAxisLabel': 'Vodoravna os',
	'heatDataSlot_valuesLabel': 'Toplinski po',
	'lineColumnComboName': 'Linijski i stupčasti grafikon',
	'lineColumnComboDescription': 'Linijski i stupčasti grafikon',
	'lineColumnComboDataSlot_lineValueLabel': 'Linijski',
	'lineColumnComboDataSlot_categoryLabel': 'Oznaka osi',
	'lineColumnComboDataSlot_columnValueLabel': 'Stupčasti',
	'mapName': 'Naslijeđena mapa',
	'mapDescription': 'Naslijeđena mapa',
	'mapDataSlot_sizeLabel': 'Veličina točke',
	'mapDataSlot_valuesLabel': 'Toplina regije',
	'mapDataSlot_sizeHeatLabel': 'Toplina točke',
	'mapDataSlot_categoriesLabel': 'Regije',
	'packedBubbleName': 'Pakirani mjehuričasti grafikon',
	'packedBubbleDescription': 'Pakirani mjehuričasti grafikon',
	'packedBubbleDataSlot_sizeLabel': 'Veličina po',
	'packedBubbleDataSlot_colorLabel': 'Boja po',
	'packedBubbleDataSlot_categoriesLabel': 'Kategorije',
	'pieName': 'Tortni grafikon',
	'pieDescription': 'Tortni grafikon',
	'pieDataSlot_valuesLabel': 'Vrijednost',
	'pieDataSlot_categoriesLabel': 'Kategorije',
	'playerName': 'Player podataka',
	'playerDescription': 'Player podataka',
	'playerDataSlot_categoriesLabel': 'Oznaka osi',
	'pointName': 'Točkasti grafikon',
	'pointDescription': 'Točkasti grafikon',
	'pointDataSlot_colorLabel': 'Boja po',
	'pointDataSlot_valuesLabel': 'Vrijednost',
	'pointDataSlot_categoriesLabel': 'Oznaka osi',
	'radialName': 'Radijalni grafikon',
	'radialDescription': 'Radijalni grafikon',
	'radialDataSlot_valuesLabel': 'Vrijednost',
	'radialDataSlot_maxSizeLabel': 'Maksimalna vrijednost',
	'radialDataSlot_categoriesLabel': 'Kategorije',
	'radialBarName': 'Radijalni trakasti',
	'radialBarDescription': 'Radijalni trakasti',
	'radialBarDataSlot_valuesLabel': 'Vrijednost',
	'radialBarDataSlot_categoriesLabel': 'Kategorije',
	'scatterPlotName': 'Raspršeni grafikon',
	'scatterPlotDescription': 'Raspršeni grafikon',
	'scatterPlotDataSlot_yAxisLabel': 'Okomita os',
	'scatterPlotDataSlot_xAxisLabel': 'Vodoravna os',
	'scatterPlotDataSlot_colorLabel': 'Boja po',
	'scatterPlotDataSlot_categoriesLabel': 'Točke',
	'stackedBarName': 'Složeni trakasti',
	'stackedBarDescription': 'Složeni trakasti',
	'stackedBarDataSlot_colorLabel': 'Boja po',
	'stackedBarDataSlot_valuesLabel': 'Vrijednost',
	'stackedBarDataSlot_categoriesLabel': 'Oznaka osi',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Vrijednost',
	'stackedColumnName': 'Složeni stupčasti',
	'stackedColumnDescription': 'Složeni stupčasti',
	'stackedColumnDataSlot_colorLabel': 'Boja po',
	'stackedColumnDataSlot_valuesLabel': 'Vrijednost',
	'stackedColumnDataSlot_categoriesLabel': 'Oznaka osi',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Vrijednost',
	'summaryChartName': 'Sumiranje',
	'summaryChartDescription': 'Sumiranje',
	'summaryChartDataSlot_valuesLabel': 'Vrijednost',
	'treeMapName': 'Mapa stabla',
	'treeMapDescription': 'Mapa stabla',
	'treeMapDataSlot_colorLabel': 'Toplinski po',
	'treeMapDataSlot_valuesLabel': 'Veličina po',
	'treeMapDataSlot_categoriesLabel': 'Razina jedan',
	'treeMapDataSlot_level3Label': 'Razina tri',
	'treeMapDataSlot_level2Label': 'Razina dva',
	'wordCloudName': 'Oblak riječi',
	'wordCloudDescription': 'Oblak riječi',
	'wordCloudDataSlot_colorLabel': 'Boja po',
	'wordCloudDataSlot_scaleLabel': 'Veličina po',
	'wordCloudDataSlot_wordLabel': 'Riječi',
	'treeMap1Cat1MeasureChartCaption': 'Mapa stabla',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Razina jedan',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Veličina po',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Palete boja',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Palete boja',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Palete boja',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Palete boja',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Palete boja',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Palete boja',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Sakrij prazno',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Sakrij legendu',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Sakrij legendu.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Položaj legende',
	'wordChart1Cat1MeasureCaption': 'Oblak riječi',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Riječi',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Veličina po',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Palete boja',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Boja teksta',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Zadrži skalu osi',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Uvijek prikaži minimalne i maksimalne vrijednosti na osima.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Sakrij prazno',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Sakrij kategorije bez pridruženih vrijednosti.',
	'missingDataSetData': 'Podaci ovog skupa podataka nisu dostupni. Osvježite skup podataka ili kontaktirajte svog administratora u vezi pristupa izvoru podataka.',
	'hideShowSummaries': 'Sakrij pokaži sumiranja',
	'crosstabName': 'Crosstab',
	'value_is_not_available': 'Nije dostupno',
	'swapRowsAndColumns': 'Zamjena redova i stupaca',
	'NoPinsCollected': 'Nema prikvačenih vizualizacija',
	'pinSearchOld': 'Pretraži moje prikvačene elemente',
	'pinDeletedToast': 'Prikvačeno je uklonjeno',
	'pinAddedToast': 'Prikvačeno je uspješno dodano u Moje prikvačene elemente',
	'pinRetrieveError': 'Ne možemo dohvatiti jedan ili više prikvačenih elemenata. Pokušajte ponovno kasnije.',
	'pinErrorTitle': 'Greška prikvačivanja',
	'pinRemove': 'Ukloni prikvačeno',
	'deletePin': 'Izbriši prikvačeno',
	'dataset_time': 'time',
	'dataset_date': 'date',
	'dataset_location': 'lokacija',
	'dataset_number': 'number',
	'dataset_text': 'tekst',
	'widgetConditionalFormatLabel': 'Prebacivanje kontrola uvjetnog formatiranja',
	'deletePinConfirmationMessage': 'Jeste li sigurni da želite izbrisati prikvačeno? To se ne može poništiti.',
	'deletePinConfirm': 'Potvrda brisanja',
	'pinDeleteError': 'Ne možemo izbrisati jedan ili više prikvačenih elemenata. Pokušajte ponovno kasnije.',
	'metadataPickerTitle': 'Kreiraj skup podataka',
	'moreTitle': 'Više',
	'remove_slider_handle': 'Ukloni držač',
	'missingFiltering': 'Nedostaje stupac:',
	'unSupportedPromptType': 'Prompt scenarij trenutno nije podržan.',
	'preAggregateLabel': 'Primijeni prompt vrijednosti iz izvora podataka',
	'postAggregateLabel': 'Primijeni prompt vrijednosti u izvještaju',
	'preAggregateText': 'Raspon koristi vrijednosti iz izvora podataka, ne koristi vrijednosti prikazane u kontrolnoj ploči.',
	'tabName_general': 'Opće', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Detalji',
	'tabName_textDetails': 'Detalji teksta', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Detalji medija', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Detalji web stranice', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Detalji slike', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Vizualizacija',
	'sectionName_canvas': 'Platno',
	'sectionName_colorsAndThemes': 'Boja i tema',
	'colorsAndThemes_legacyWarning': 'Tekuća kontrolna ploča koristi temu iz ranijeg izdanja. Promjena teme i spremanje kontrolne ploče trajno će ukloniti pristup ranijoj paleti tema.',
	'sectionName_details': 'Detalji',
	'sectionName_positionAndStyle': 'Položaj i stil',
	'sectionName_appearance': 'Izgled', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Napredno',
	'sectionName_layout': 'Izgled', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Kartice',
	'sectionName_tabTitle': 'Oznaka',
	'sectionName_tabBackground': 'Pozadina',
	'addDataSourceDialogTitle': 'Dodavanje izvora podataka',
	'addDataSourceDialogButtonLabel': 'Dodaj',
	'shapesDoubleChevron': 'Dvostruki ševron',
	'widgetsPanelTitle': 'Grafički elementi',
	'widgetsPanelBasicsTab': 'Osnove',
	'widgetsPanelImageLibraryTab': 'Slike',
	'widgetsPanelSectionStandard': 'Standardni',
	'widgetsPanelSectionAdvanced': 'Napredno',
	'widgetsPanelSectionShapes': 'Oblici',
	'customWidgetsTitle': 'Prilagođeni grafički elementi',
	'filterItemCanvasMove': 'Dodaj na platno',
	'filterOverflowMenu_Global': 'Dodatni izbornik svih kartica',
	'filterOverflowMenu_Tab': 'Dodatni izbornik ove kartice',
	'filterOverflowMenu_Item': 'Dodatni izbornik filtera',
	'filterOverflowMenu_Single': 'Dodatni izbornik',
	'filterItemEdit': 'Uredi vrijednosti filtera',
	'filterDeleteAllItems': 'Izbriši sve filtere',
	'filterClearAllItems': 'Isprazni sve filtere',
	'filterClearSelection': 'Isprazni filter',
	'filterPlayerMode': 'Pokaži player',
	'filterStaticMode': 'Pokaži listu',
	'filterInvertSelection': 'Preokreni filter',
	'filterIconLabel_Global': 'Sve kartice',
	'filterIconLabel_Single': 'Filteri',
	'filterIconLabel_Tab': 'Ova kartica',
	'filterIconTooltip_Global': 'Sve kartice',
	'filterIconTooltip_Tab': 'Ova kartica',
	'filterIconTooltip_Single': 'Filteri',
	'filterItemDelete': 'Izbriši filter',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'sve osim: %{from}-%{to}',
	'filterExcept': 'osim %{values}',
	'filterAll': 'Sve',
	'filterBlank': '(prazno)',
	'filterDisableRangeInvert': 'Nije dostupno kad se ovaj stupac nalazi u filteru "Sve kartice".',
	'filterDisableHierarchyInvert': 'Nije dostupno kad je ovaj stupac filter hijerarhije.',
	'filterSelectedOfTotal': '%{selected} od %{totalMembers}',
	'filter_date_before': 'Prije %{to}',
	'filter_date_before_except': 'Ne prije %{to}',
	'filter_date_after': 'Poslije %{from}',
	'filter_date_after_except': 'Ne poslije %{from}',
	'filter_date_between': 'Između  %{from}-%{to}',
	'filter_date_between_except': 'Ne između %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Povucite podatke i ispustite ih ovdje za filtriranje svih kartica.',
	'filter_drag_and_drop_current_tab': 'Povucite podatke i ispustite ih ovdje za filtriranje ove kartice.',
	'filter_drag_and_drop_single_dock': 'Povucite i ispustite podatke ovdje za filtriranje.',
	'errMsgFilterItemGenericTitle': 'Vrijednosti filtera se ne mogu učitati',
	'widgetChromeRotate': 'Rotiraj',
	'toolbarRegionLabel': 'Traka s alatima',
	'toolbarActionDelete': 'Izbriši',
	'toolbarActionGroup': 'Grupa',
	'toolbarActionUngroup': 'Poništi grupiranje',
	'toolbarActionOrderToFront': 'Pošalji u prednji plan',
	'toolbarActionOrderToBack': 'Pošalji u pozadinu',
	'toolbarActionEditTitle': 'Uredi naslov',
	'toolbarActionWrapTitle': 'Omotaj naslov',
	'toolbarActionPin': 'Prikupi',
	'toolbarActionPinOld': 'Prikvači',
	'toolbarActionAlign': 'Poravnaj',
	'alignWidgetLeft': 'Lijevo',
	'alignWidgetCenter': 'Sredina',
	'alignWidgetRight': 'Desno',
	'alignWidgetTop': 'Vrh',
	'alignWidgetMiddle': 'Sredina',
	'alignWidgetBottom': 'Dno',
	'toolbarChangeVisualization': 'Promijeni vizualizaciju',
	'multipurposeHeader': 'Izaberite tip grafičkog elementa',
	'multipurposePlaceholderText': 'Izaberite jedan od grafičkih elemenata da započnete.',
	'live_label': 'Grafikon',
	'filter_label': 'Filter',
	'one_named_live': '%{name} grafikon',
	'one_named_live_numbered': '%{name} grafikon (%{number})',
	'one_unknown_live': 'Grafikon',
	'one_unknown_live_numbered': 'Grafikon (%{number})',
	'few_live': 'Grupa od %{count} grafikona',
	'many_live': 'Grupa od %{count} grafikona',
	'one_custom': 'Prilagođeni grafički element',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} filter',
	'one_named_filter_numbered': '%{name} filter (%{number})',
	'one_unknown_filter': 'Filter',
	'one_unknown_filter_numbered': 'Filter (%{number})',
	'few_filter': 'Grupa od %{count} filtera',
	'many_filter': 'Grupa od %{count} filtera',
	'LIVE_bar_has_mapping': '%{values} trakasti grafikon',
	'LIVE_bar_has_mapping_numbered': '%{values} trakasti grafikon (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} po %{values} trakasti grafikon',
	'LIVE_bar_opt_mapping_numbered': '%{categories} po %{values} trakasti grafikon (%{number})',
	'LIVE_bar_no_mapping': 'Prazan trakasti grafikon',
	'LIVE_bar_no_mapping_numbered': 'Prazan trakasti grafikon (%{number})',
	'LIVE_bar_named': '%{name} trakasti grafikon',
	'LIVE_bar_named_numbered': '%{name} trakasti grafikon (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} složeni trakasti grafikon',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} složeni trakasti grafikon (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} po %{values} složeni trakasti grafikon',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} po %{values} složeni trakasti grafikon (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Prazan složeni trakasti grafikon',
	'LIVE_stacked_bar_no_mapping_numbered': 'Prazan složeni trakasti grafikon (%{number})',
	'LIVE_stacked_bar_named': '%{name} složeni trakasti grafikon',
	'LIVE_stacked_bar_named_numbered': '%{name} složeni trakasti grafikon (%{number})',
	'LIVE_bubble_has_mapping': '%{categories} po %{x} i %{y} mjehuričasti grafikon',
	'LIVE_bubble_has_mapping_numbered': '%{categories} po %{x} i %{y} mjehuričasti grafikon (%{number})',
	'LIVE_bubble_no_mapping': 'Prazan mjehuričasti grafikon',
	'LIVE_bubble_no_mapping_numbered': 'Prazan mjehuričasti grafikon (%{number})',
	'LIVE_bubble_named': '%{name} mjehuričasti grafikon',
	'LIVE_bubble_named_numbered': '%{name} mjehuričasti grafikon (%{number})',
	'LIVE_composite_has_mapping': '%{categories} po %{columnValue} i%{lineValue} kompozitni grafikon',
	'LIVE_composite_has_mapping_numbered': '%{categories} po %{columnValue} i %{lineValue} kompozitni grafikon (%{number})',
	'LIVE_composite_no_mapping': 'Prazan kompozitni grafikon',
	'LIVE_composite_no_mapping_numbered': 'Prazan kompozitni grafikon (%{number})',
	'LIVE_composite_named': '%{name} kompozitni grafikon',
	'LIVE_composite_named_numbered': '%{name} kompozitni grafikon (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} stablo odlučivanja',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} stablo odlučivanja (%{number})',
	'LIVE_decision_tree_no_mapping': 'Prazno stablo odlučivanja',
	'LIVE_decision_tree_no_mapping_numbered': 'Prazno stablo odlučivanja (%{number})',
	'LIVE_decision_tree_named': '%{name} stablo odlučivanja',
	'LIVE_decision_tree_named_numbered': '%{name} stablo odlučivanja (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} pakirani mjehuričasti grafikon',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} pakirani mjehuričasti grafikon (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Prazan pakirani mjehuričasti grafikon',
	'LIVE_packed_bubble_no_mapping_numbered': 'Prazan pakirani mjehuričasti grafikon (%{number})',
	'LIVE_packed_bubble_named': '%{name} pakirani mjehuričasti grafikon',
	'LIVE_packed_bubble_named_numbered': '%{name} pakirani mjehuričasti grafikon (%{number})',
	'LIVE_pie_has_mapping': '%{categories} po %{values} tortni grafikon',
	'LIVE_pie_has_mapping_numbered': '%{categories} po %{values} tortni grafikon  (%{number})',
	'LIVE_pie_no_mapping': 'Prazan tortni grafikon',
	'LIVE_pie_no_mapping_numbered': 'Prazan tortni grafikon (%{number})',
	'LIVE_pie_named': '%{name} tortni grafikon',
	'LIVE_pie_named_numbered': '%{name} tortni grafikon (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} po %{values} prstenasti grafikon',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} po %{values} prstenasti grafikon (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Prazan prstenasti grafikon',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Prazan prstenasti grafikon (%{number})',
	'LIVE_pie_as_donut_named': '%{name} prstenasti grafikon',
	'LIVE_pie_as_donut_named_numbered': '%{name} prstenasti grafikon (%{number})',
	'LIVE_line_has_mapping': '%{categories} po %{values} linijski grafikon',
	'LIVE_line_has_mapping_numbered': '%{categories} po %{values} linijski grafikon (%{number})',
	'LIVE_line_no_mapping': 'Prazan linijski grafikon',
	'LIVE_line_no_mapping_numbered': 'Prazan linijski grafikon (%{number})',
	'LIVE_line_named': '%{name} linijski grafikon',
	'LIVE_line_named_numbered': '%{name} linijski grafikon (%{number})',
	'LIVE_area_has_mapping': '%{categories} po %{values} površinski grafikon',
	'LIVE_area_has_mapping_numbered': '%{categories} po %{values} površinski grafikon (%{number})',
	'LIVE_area_no_mapping': 'Prazan površinski grafikon',
	'LIVE_area_no_mapping_numbered': 'Prazan površinski grafikon (%{number})',
	'LIVE_area_named': '%{name} površinski grafikon',
	'LIVE_area_named_numbered': '%{name} površinski grafikon (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} po %{values} složeni površinski grafikon postotaka',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} po %{values} složeni površinski grafikon postotaka (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Prazan složeni površinski grafikon postotaka',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Prazan složeni površinski grafikon postotaka (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} složeni površinski grafikon postotaka',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} složeni površinski grafikon postotaka (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} toplinska mapa',
	'LIVE_heatmap_has_mapping_numbered': '%{color} toplinska mapa (%{number})',
	'LIVE_heatmap_no_mapping': 'Prazna toplinska mapa',
	'LIVE_heatmap_no_mapping_numbered': 'Prazna toplinska mapa (%{number})',
	'LIVE_heatmap_named': '%{name} toplinska mapa',
	'LIVE_heatmap_named_numbered': '%{name} toplinska mapa (%{number})',
	'LIVE_network_opt_mapping': '%{categories} po %{series} i %{values} mreža',
	'LIVE_network_opt_mapping_numbered': '%{categories} po %{series} i %{values} mreža  (%{number})',
	'LIVE_network_has_mapping': '%{categories} po %{series} mreža',
	'LIVE_network_has_mapping_numbered': '%{categories} po %{series} mreža  (%{number})',
	'LIVE_network_no_mapping': 'Prazna mreža',
	'LIVE_network_no_mapping_numbered': 'Prazna mreža (%{number})',
	'LIVE_network_named': '%{name} mreža',
	'LIVE_network_named_numbered': '%{name} mreža (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} po %{values} radijalni trakasti grafikon',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} po %{values} radijalni trakasti grafikon (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} radijalni trakasti grafikon',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} radijalni trakasti grafikon (%{number})',
	'LIVE_radial_bar_no_mapping': 'Prazan radijalni trakasti grafikon',
	'LIVE_radial_bar_no_mapping_numbered': 'Prazan radijalni trakasti grafikon (%{number})',
	'LIVE_radial_bar_named': '%{name} radijalni trakasti grafikon',
	'LIVE_radial_bar_named_numbered': '%{name} radijalni trakasti grafikon (%{number})',
	'LIVE_spiral_has_mapping': '%{values} spiralni grafikon',
	'LIVE_spiral_has_mapping_numbered': '%{values} spiralni grafikon (%{number})',
	'LIVE_spiral_no_mapping': 'Prazan spiralni grafikon',
	'LIVE_spiral_no_mapping_numbered': 'Prazan spiralni grafikon (%{number})',
	'LIVE_spiral_named': '%{name} spiralni grafikon',
	'LIVE_spiral_named_numbered': '%{name} spiralni grafikon (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} po %{size} mapa stabla',
	'LIVE_treemap_has_mapping_numbered': '%{categories} po %{size} mapa stabla (%{number})',
	'LIVE_treemap_no_mapping': 'Prazna mapa stabla',
	'LIVE_treemap_no_mapping_numbered': 'Prazna mapa stabla (%{number})',
	'LIVE_treemap_named': '%{name} mapa stabla',
	'LIVE_treemap_named_numbered': '%{name} mapa stabla (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} oblak riječi',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} oblak riječi (%{number})',
	'LIVE_wordcloud_no_mapping': 'Prazan oblak riječi',
	'LIVE_wordcloud_no_mapping_numbered': 'Prazan oblak riječi (%{number})',
	'LIVE_wordcloud_named': '%{name} oblak riječi',
	'LIVE_wordcloud_named_numbered': '%{name} oblak riječi (%{number})',
	'LIVE_data_player_has_mapping': '%{category} data player',
	'LIVE_data_player_has_mapping_numbered': '%{category} data player (%{number})',
	'LIVE_data_player_no_mapping': 'Prazan data player',
	'LIVE_data_player_no_mapping_numbered': 'Prazan data player (%{number})',
	'LIVE_data_player_named': '%{name} data player',
	'LIVE_data_player_named_numbered': '%{name} data player (%{number})',
	'LIVE_map_has_mapping': 'Mapa %{locations}',
	'LIVE_map_has_mapping_numbered': 'Mapa %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Prazna mapa',
	'LIVE_map_no_mapping_numbered': 'Prazna mapa (%{number})',
	'LIVE_map_named': 'Mapa %{name}',
	'LIVE_map_named_numbered': 'Mapa %{name} (%{number})',
	'LIVE_point_has_mapping': '%{categories} po %{values} točkasti grafikon',
	'LIVE_point_has_mapping_numbered': '%{categories} po %{values} točkasti grafikon (%{number})',
	'LIVE_point_no_mapping': 'Prazan točkasti grafikon',
	'LIVE_point_no_mapping_numbered': 'Prazan točkasti grafikon (%{number})',
	'LIVE_point_named': '%{name} točkasti grafikon',
	'LIVE_point_named_numbered': '%{name} točkasti grafikon  (%{number})',
	'LIVE_column_has_mapping': '%{values} stupčasti grafikon',
	'LIVE_column_has_mapping_numbered': '%{values} stupčasti grafikon (%{number})',
	'LIVE_column_opt_mapping': '%{categories} po %{values} stupčasti grafikon',
	'LIVE_column_opt_mapping_numbered': '%{categories} po %{values} stupčasti grafikon  (%{number})',
	'LIVE_column_no_mapping': 'Prazan stupčasti grafikon',
	'LIVE_column_no_mapping_numbered': 'Prazan stupčasti grafikon (%{number})',
	'LIVE_column_named': '%{name} stupčasti grafikon',
	'LIVE_column_named_numbered': '%{name} stupčasti grafikon (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} složeni stupčasti grafikon',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} složeni stupčasti grafikon (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} po %{values} složeni stupčasti grafikon',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} po %{values} složeni stupčasti grafikon (%{number})',
	'LIVE_stacked_column_no_mapping': 'Prazan složeni stupčasti grafikon',
	'LIVE_stacked_column_no_mapping_numbered': 'Prazan složeni stupčasti grafikon (%{number})',
	'LIVE_stacked_column_named': '%{name} složeni stupčasti grafikon',
	'LIVE_stacked_column_named_numbered': '%{name} složeni stupčasti grafikon (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories} po %{x} i%{y} raspršeni grafikon',
	'LIVE_scatter_opt_mapping_numbered': '%{categories} po %{x} i %{y} raspršeni grafikon (%{number})',
	'LIVE_scatter_has_mapping': '%{x} prema %{y} raspršeni grafikon',
	'LIVE_scatter_has_mapping_numbered': '%{x} prema %{y} raspršeni grafikon (%{number})',
	'LIVE_scatter_no_mapping': 'Prazan raspršeni grafikon',
	'LIVE_scatter_no_mapping_numbered': 'Prazan raspršeni grafikon (%{number})',
	'LIVE_scatter_named': '%{name} raspršeni grafikon',
	'LIVE_scatter_named_numbered': '%{name} raspršeni grafikon (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} vodopad grafikon',
	'LIVE_waterfall_has_mapping_numbered': '%{values} vodopad grafikon (%{number})',
	'LIVE_waterfall_no_mapping': 'Prazan vodopad grafikon',
	'LIVE_waterfall_no_mapping_numbered': 'Prazan vodopad grafikon (%{number})',
	'LIVE_waterfall_named': '%{name} vodopad grafikon',
	'LIVE_waterfall_named_numbered': '%{name} vodopad grafikon (%{number})',
	'LIVE_empty_visualization_hint_title': 'Izgradite vašu vizualizaciju',
	'LIVE_empty_visualization_hint_description': 'Povucite stupce i ispustite ih ovdje ili na priključnice na lijevoj strani.',
	'LIVE_slots_required_field_description': '%{asterisk} označava obavezno polje',
	'LIVE_slots_drag_and_drop_description': 'Povucite podatke i ispustite ih na pozicije gore da biste izgradili i filtrirali vizualizaciju.',
	'requiredField': 'Obavezno polje',
	'fullScreenEnter': 'Otvori na cijelom zaslonu',
	'fullScreenClose': 'Izađi iz prikaza na cijelom zaslonu',
	'noExtraText_multipurpose': 'Znak rezerviranog mjesta za razne svrhe',
	'noExtraText_multipurpose_numbered': 'Znak rezerviranog mjesta za više namjena (%{number})',
	'one_placeholder_vis': 'Znak rezerviranog mjesta za vizualizaciju',
	'one_placeholder_vis_numbered': 'Znak rezerviranog mjesta vizualizacije (%{number})',
	'one_placeholder_text': 'Znak rezerviranog mjesta za tekst',
	'one_placeholder_text_numbered': 'Znak rezerviranog mjesta za tekst (%{number})',
	'few_placeholder_text': 'Grupa od %{count} znakova rezerviranih mjesta',
	'many_placeholder_text': 'Grupa od %{count} znakova rezerviranih mjesta',
	'filter_includesAll': 'Uključi sve',
	'timeline_filter_moved_to': 'Filter vremenske skale %{id} premješten na %{time}',
	'timelineSettingsButton': 'Opcije izvođenja',
	'autoPlay': 'Izvedi sve scene',
	'loop': 'Petlja',
	'noSceneTransitionLabel': 'Nijedan',
	'sceneTransitionPropertyLabel': 'Prijelaz scene',
	'animatedPathSceneTransitionLabel': 'Animirana staza',
	'sweepSceneTransitionLabel': 'Pometi',
	'propAniAnimation': 'Animacija',
	'propAniTypeEntrance': 'Ulazna animacija',
	'propAniDirectionIn': 'Smjer ulaza',
	'propAniTypeExit': 'Izlazna animacija',
	'propAniDirectionOut': 'Smjer izlaza',
	'propAniDirection': 'Smjer',
	'timelineAnimationProperties': 'Otvori svojstva animacije',
	'editStoryCoachMarkTitle': 'Uredi priču',
	'editStoryCoachMarkContents': 'Kliknite ikonu olovke i uredite ovu priču.',
	'addDataStoryCoachMarkContents': 'Povucite i ispustite podatke iz panela podataka u priču.',
	'expandSceneCoachmarkTitle': 'Otvori vremensku crtu',
	'expandSceneCoachmarkContents': 'Animirajte scenu prilagođavanjem vidljivosti objekta na temelju vremena i trajanja.',
	'overviewCoachmarkTitle': 'Pregled scena',
	'overviewCoachmarkContents': 'Koristite pregled scena na početku i kraju priče kako bi prikazali sliku svih scena zajedno. Na pregledu scena kliknite i povucite scenu da ju zamijenite s drugom scenom. Možete pokazati ili sakriti pregled scena u svojstvima priče.',
	'animatedPathCoachmarkTitle': 'Animirana staza',
	'animatedPathCoachmarkContents': 'Da biste animirali objekt iz jedne u drugu scenu, duplicirajte scenu s objektom. Zatim, pomaknite, promijenite veličinu ili rotirajte\nduplicirani objekt na novu scenu.',
	'tabName_animation': 'Animacija',
	'textWidgetIconPlaceholderText': 'Kliknite za dodavanje teksta',
	'buildVisHeader': 'Kreirajte vizualizaciju',
	'visIconPlaceholderText': 'Povucite i ispustite polja da izgradite vizualizaciju',
	'launchNewExplore': 'Novo istraživanje',
	'addTo': 'Dodaj u',
	'addToExisting': 'Dodaj u postojeće...',
	'exploreData': 'Istraži',
	'explore_remove_widget_styles': 'Prilagođena svojstva vizualizacije kao što su postavke boje, neće trajati u istraživanju.',
	'editNotebook': 'Uredi grafički element',
	'thumbnails_error_fetching': 'Greška kod dohvata sličica',
	'copy': '%{count} sredstvo(a) kopirano',
	'specConvertErr': 'Pojavila se greška tijekom lijepljenja ili konvertiranja specifikacija kontrolne ploče',
	'specCopyErr': 'Greška prilikom kopiranja specifikacija kontrolne ploče',
	'pasteNotSupportedErr': 'Lijepljenje iz %{name} nije podržano.',
	'reportParam': 'izvještaj',
	'filterWidgetCopyWarn': 'Filter vizualizacije nije kopiran jer Filteri nisu u ovom trenutku podržani.',
	'upgradingDashboard': 'Nadogradnja "%{name}" za%{version}...',
	'upgradeComplete': 'Nadogradnja je dovršena',
	'individualTabProperties': 'Svojstva pojedine kartice',
	'propMasterTabStylesLabel': 'Glavni stil kartice',
	'propTabPosition': 'Položaj kartice',
	'propTabTitle': 'Naslov',
	'propTabBackgroundColor': 'Boja za ispunu',
	'propTabTextColor': 'Boja naslova',
	'propTabSelectedBarColor': 'Boja izabrane trake',
	'propTabRestoreDefaults': 'Vrati defaulte',
	'propIndividualTabStylesLabel': 'Stil pojedine kartice',
	'propIndividualTabStylesAriaLabel': 'Otvori svojstva stila pojedinačne kartice',
	'propTabIconPosition': 'Položaj ikone',
	'propLeftTitle': 'Lijevo od naslova',
	'propRightTitle': 'Desno od naslova',
	'propTopTitle': 'Iznad naslova',
	'propBottomTitle': 'Ispod naslova',
	'propTabIconLabel': 'Vizualno',
	'propTabIcon': 'Ikona',
	'propTabIconColor': 'Boja ikone',
	'no_icon': 'Prazno',
	'announcement': 'Obavijest',
	'api': 'API',
	'archive': 'Arhiva',
	'asset': 'Sredstvo',
	'attachment': 'Prilog',
	'audio': 'Audio',
	'bee': 'Pčela',
	'blog': 'Blog',
	'bookmark': 'Knjiška oznaka',
	'calendar': 'Kalendar',
	'camera': 'Kamera',
	'capability': 'Mogućnost',
	'catalog': 'Katalog',
	'chat_message': 'Poruka razgovora',
	'checkout_cart': 'Pregledaj košaricu',
	'client': 'Klijent',
	'clock': 'Sat',
	'cloud': 'Oblak',
	'code': 'Šifra',
	'data_quality': 'Kvaliteta podataka',
	'folder': 'Folderi',
	'forum': 'Forum',
	'glasses': 'Naočale',
	'group': 'Grupa',
	'hat': 'Šešir',
	'headphone': 'Slušalice',
	'hills': 'Brda',
	'home': 'Početak',
	'idea': 'Ideja',
	'image': 'Slika',
	'inventory': 'Inventar',
	'like': 'Sviđa mi se',
	'link': 'Veza',
	'location': 'Lokacija',
	'manage': 'Upravljanje',
	'pen': 'Olovka',
	'mobile_phone': 'Mobitel',
	'music': 'Glazba',
	'notifications': 'Obavijesti',
	'paint': 'Boja',
	'payment': 'Plaćanje',
	'password_key': 'Ključ lozinke',
	'people': 'Osobe',
	'person': 'Osoba',
	'phone': 'Telefon',
	'pin': 'Prikvači',
	'print': 'Ispis',
	'recording': 'Snimanje',
	'repository': 'Spremište',
	'role': 'Uloga',
	'search': 'Traži',
	'properties': 'Svojstva',
	'speaker': 'Zvučnik',
	'star': 'Zvjezdica',
	'tag': 'Oznaka',
	'thumbs_up': 'Palac gore',
	'thumbs_down': 'Palac dolje',
	'tools': 'Alati',
	'traffic': 'Promet',
	'trash': 'Smeće',
	'twitter': 'Twitter',
	'unknown': 'Nepoznato',
	'user': 'Korisnik',
	'venn_diagram': 'Venn dijagram',
	'video': 'Video',
	'view': 'Pogled',
	'warning': 'Upozorenje',
	'watch': 'Promatraj',
	'watson': 'Watson',
	'wikis': 'Wikiji',
	'workspace': 'Radni prostor',
	'world': 'Svijet',
	'OnLoadFilterModifierDatasourceMismatch': 'Filteri se neće primijeniti na cilj jer kontrolne ploče koriste različite izvore.',
	'OnLoadFilterModifierColumnMismatch': 'Jedan ili više filtera nije primijenjeno jer se ne može pronaći odgovarajući stupac (ci).',
	'eventGroupButtonLabel': 'Pregled veza s grafičkim elementima',
	'dockToolbar': 'Usidri traku alata',
	'undockToolbar': 'Odsidri traku alata',
	'propShowTitle': 'Pokaži naslov'
});
